import React from "react";
import { FaEnvelope, FaLinkedin, FaGithub } from "react-icons/fa";

const Contact = () => {
  return (
    <section
      id="contact"
      style={{
        padding: "60px 20px",
        backgroundColor: "#000",
        color: "#fff",
        textAlign: "center",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <h2
        style={{
          fontSize: "2.5rem",
          marginBottom: "30px",
          color: "#f0f2f2ff",
          fontWeight: "700",
        }}
      >
        Contact Me
      </h2>

      <p style={{ fontSize: "1.2rem", marginBottom: "15px" }}>
        <FaEnvelope
          style={{
            marginRight: "10px",
            color: "#00b894",
            verticalAlign: "middle",
          }}
        />
        <a
          href="mailto:shreyadesai8910@gmail.com"
          style={{
            color: "#fff",
            textDecoration: "none",
            transition: "color 0.3s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#00b894")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#fff")}
        >
          shreyadesai8910@gmail.com
        </a>
      </p>

      <p style={{ fontSize: "1.2rem", marginBottom: "15px" }}>
        <FaLinkedin
          style={{
            marginRight: "10px",
            color: "#00b894",
            verticalAlign: "middle",
          }}
        />
        <a
          href="https://www.linkedin.com/in/shreeya-desai20/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#fff",
            textDecoration: "none",
            transition: "color 0.3s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#00b894")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#fff")}
        >
          linkedin.com/in/shreeya-desai20
        </a>
      </p>

      <p style={{ fontSize: "1.2rem" }}>
        <FaGithub
          style={{
            marginRight: "10px",
            color: "#00b894",
            verticalAlign: "middle",
          }}
        />
        <a
          href="https://github.com/shreeya20desai"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#fff",
            textDecoration: "none",
            transition: "color 0.3s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#00b894")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#fff")}
        >
          github.com/shreeya
        </a>
      </p>
    </section>
  );
};

export default Contact;
